export default __webpack_public_path__ + "static/media/rabbithole.c9d14735.png";